<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div class="spinner" *ngIf="loading">
	<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<h2 *ngIf="!embedded" class="main-heading">
	<span style="color: #673ab6">Kurd Shopping</span>

	for {{ platformTitle }} - Release Notes
</h2>

<div class="row mt-5">
	<div class="col-sm-4 mb-4">
		<h6 *ngIf="!embedded">Release Notes</h6>

		<ul *ngIf="!embedded" class="sidebar">
			<li [routerLink]="['/platform-updates']" [queryParams]="{ platform: '1', embedded: embedded }">iOS Release Notes</li>

			<li [routerLink]="['/platform-updates']" [queryParams]="{ platform: '2', embedded: embedded }">Android Release Notes</li>

			<li [routerLink]="['/platform-updates']" [queryParams]="{ platform: '3', embedded: embedded }">Web Release Notes</li>
		</ul>
	</div>

	<div class="col-sm-8 mb-4">
		<div *ngFor="let result of Result">
			<h4 style="font-weight: 600">{{ result.versionNumber }}</h4>

			<p class="description" [innerHTML]="result.description"></p>

			<mat-divider class="mt-3 mb-3"></mat-divider>
		</div>
	</div>
</div>

<ng-container *ngIf="load">
	<div class="row">
		<div class="col-12 text-center">
			<span (click)="LoadMore()" class="owner_btn text-center">
				Load Previous Updates

				<span *ngIf="showLoad"><img [src]="'/assets/images/loading.gif' | s3Image" /></span>
			</span>
		</div>
	</div>
</ng-container>
